import { z } from 'src/lib';
import { OperacionLEPFields } from './fields';
import { schemaEntityWithId } from 'src/types';

export const schemaOperacionLEP = z
    .object({
        [OperacionLEPFields.CodOperacionLEPEstado]: z.number(),
        [OperacionLEPFields.DescOperacionLEPEstado]: z.string(),
        [OperacionLEPFields.CodPais]: z.number(),
        [OperacionLEPFields.NombrePais]: z.string(),
        [OperacionLEPFields.FechaAprobacion]: z.coerce.date(),
        [OperacionLEPFields.FechaVencimiento]: z.coerce.date(),
        [OperacionLEPFields.CodUnidadNegocio]: z.number(),
        [OperacionLEPFields.UnidadNegocio]: z.string(),
        [OperacionLEPFields.CodSectorComercial]: z.number(),
        [OperacionLEPFields.SectorComercial]: z.string(),
        [OperacionLEPFields.FechaAprobacionFinal]: z.coerce.date().nullable(),
        [OperacionLEPFields.FechaAlta]: z.coerce.date(),
        [OperacionLEPFields.IdUsuarioAlta]: z.number(),
        [OperacionLEPFields.NombreUsuarioAlta]: z.string(),
        [OperacionLEPFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionLEPFields.MailUsuarioAlta]: z.string(),
        [OperacionLEPFields.FechaUltMod]: z.coerce.date(),
        [OperacionLEPFields.IdUsuarioUltMod]: z.number(),
        [OperacionLEPFields.EstadoFinalizado]: z.boolean(),
        [OperacionLEPFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionLEPFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionLEPFields.PermiteAgregarEmisores]: z.boolean(),
        [OperacionLEPFields.IdMensaje]: z.number().nullable()
    })
    .merge(schemaEntityWithId);

export type OperacionLEP = z.infer<typeof schemaOperacionLEP>;
